import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';
import { Security } from '../utils/security';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent = icon;

  if (!IconComponent && name) {
    // Rafter SAST: Prevent Prototype Pollution by validating the icon name
    const iconKey = `Fi${name}`;
    // Only resolve if it's a valid key in the FiIcons object and not a prototype property
    IconComponent = Security.safeGet(FiIcons, iconKey);
  }

  return IconComponent ? React.createElement(IconComponent, props) : <FiAlertTriangle {...props} />;
};

export default SafeIcon;